/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Staff_NoneInputs */

const th_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีข้อมูลผู้ฝึกสอน`)
};

const en_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No coaching staff recorded.`)
};

const ja_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コーチの登録はありません。`)
};

const zh_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未登记教练组。`)
};

const es_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cuerpo técnico registrado.`)
};

const pt_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma comissão técnica registrada.`)
};

const id_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada staf pelatih yang terdaftar.`)
};

const fr_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun staff technique enregistré.`)
};

const tl_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakatalang coaching staff.`)
};

const vi_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa ghi nhận ban huấn luyện.`)
};

const ko_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록된 코칭스태프가 없습니다.`)
};

const de_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Trainerstab hinterlegt.`)
};

const ru_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренерский штаб не указан.`)
};

const tr_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıtlı teknik ekip yok.`)
};

const it_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuno staff tecnico registrato.`)
};

const pl_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak zapisanego sztabu.`)
};

const uk_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тренерський штаб не вказано.`)
};

const hi_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई कोचिंग स्टाफ़ दर्ज नहीं है।`)
};

const ar_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد جهاز فني مسجَّل.`)
};

const ms_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kakitangan kejurulatihan direkodkan.`)
};

const bn_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও কোচিং স্টাফ নথিভুক্ত নেই।`)
};

const zh_tw2_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未登錄教練團。`)
};

const zh_hk2_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未登錄教練團。`)
};

const ur_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی کوچنگ اسٹاف درج نہیں۔`)
};

const fa_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کادر فنی ثبت نشده است.`)
};

const sw_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna wakufunzi waliosajiliwa.`)
};

const nl_coaching_staff_none = /** @type {(inputs: Coaching_Staff_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen technische staf vastgelegd.`)
};

/**
* | output |
* | --- |
* | "No coaching staff recorded." |
*
* @param {Coaching_Staff_NoneInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const coaching_staff_none = /** @type {((inputs?: Coaching_Staff_NoneInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Staff_NoneInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_coaching_staff_none(inputs)
	if (locale === "ja") return ja_coaching_staff_none(inputs)
	if (locale === "zh") return zh_coaching_staff_none(inputs)
	if (locale === "es") return es_coaching_staff_none(inputs)
	if (locale === "pt") return pt_coaching_staff_none(inputs)
	if (locale === "id") return id_coaching_staff_none(inputs)
	if (locale === "fr") return fr_coaching_staff_none(inputs)
	if (locale === "tl") return tl_coaching_staff_none(inputs)
	if (locale === "vi") return vi_coaching_staff_none(inputs)
	if (locale === "ko") return ko_coaching_staff_none(inputs)
	if (locale === "de") return de_coaching_staff_none(inputs)
	if (locale === "ru") return ru_coaching_staff_none(inputs)
	if (locale === "tr") return tr_coaching_staff_none(inputs)
	if (locale === "it") return it_coaching_staff_none(inputs)
	if (locale === "pl") return pl_coaching_staff_none(inputs)
	if (locale === "uk") return uk_coaching_staff_none(inputs)
	if (locale === "hi") return hi_coaching_staff_none(inputs)
	if (locale === "ar") return ar_coaching_staff_none(inputs)
	if (locale === "ms") return ms_coaching_staff_none(inputs)
	if (locale === "bn") return bn_coaching_staff_none(inputs)
	if (locale === "zh-TW") return zh_tw2_coaching_staff_none(inputs)
	if (locale === "zh-HK") return zh_hk2_coaching_staff_none(inputs)
	if (locale === "ur") return ur_coaching_staff_none(inputs)
	if (locale === "fa") return fa_coaching_staff_none(inputs)
	if (locale === "sw") return sw_coaching_staff_none(inputs)
	if (locale === "nl") return nl_coaching_staff_none(inputs)
	return en_coaching_staff_none(inputs)
});